import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import { SortEnumType } from 'gql/graphql';
import { getWorkOrderVersionListItems } from 'pages/Project/Common/utils';

import { useEffect, useMemo } from 'react';

import { uerWorkOrderChangePreviousVersionsGql } from '../exportWorkOrderChangeAnalyticsQueries';

const requestId = 'uerGetExportWorkOrderVersions';

export const useUerWorkOrderVersionsItems = (workOrderChangeId: number, withEffect = true) => {
    const variables = useMemo(
        () => ({
            workOrderChangeId,
            order: {
                workOrderVersionItem: {
                    id: SortEnumType.Desc,
                },
            },
        }),
        [workOrderChangeId],
    );

    const [resetData] = useResetStoreData({ requestId });

    const [data] = useRequest({
        requestId,
        query: uerWorkOrderChangePreviousVersionsGql,
        variables,
        withEffect,
    });

    useEffect(() => {
        resetData(undefined);
    }, [resetData]);

    // TODO: bim статус версии ?
    return useMemo(
        () => getWorkOrderVersionListItems((data?.uerWorkOrderChangePreviousVersions as any) ?? []),
        [data?.uerWorkOrderChangePreviousVersions],
    );
};
